import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  CardHeader,
  Divider,
  CardContent,
  Box,
  FormControl,
  NativeSelect,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import uuid from "uuid";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DataContext from "../../../context/DataContext";
import { addZeroes } from "../../utils";

const columns = [
  {
    field: "name",
    headerName: "Client",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "avg_cost_per_hire",
    headerName: "Avg CPH",
    flex: 1,
    headerAlign: "center",
    align: "center",
    description: "Cost Per Hire (Client Average)",
    valueGetter: (params) => {
      if (params.row.avg_cost_per_hire === null) {
        return null;
      } else {
        return `$${addZeroes(params.row.avg_cost_per_hire)}`;
      }
    },
  },
  {
    field: "total_hiring_costs",
    headerName: "Hiring Costs",
    flex: 1,
    headerAlign: "center",
    align: "center",
    description: "Hiring Costs (Client Total)",
    renderCell: (params) => {
      if (params.row.total_hiring_costs === null) {
        return null;
      } else {
        return `$${addZeroes(params.row.total_hiring_costs)}`;
      }
    },
  },
  {
    field: "avg_turnover_rate",
    headerName: "AVG TR",
    description: "Turnover Rate (Client Average)",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
    // renderCell: (params) => {
    //   if (params.row.avg_turnover_rate === null) {
    //     return null;
    //   } else {
    //     return `${params.row.avg_turnover_rate * 100}%`;
    //   }
    // },
    valueGetter: (params) => {
      if (params.row.avg_turnover_rate === null) {
        return null;
      } else {
        return `${params.row.avg_turnover_rate * 100}%`;
      }
    },
  },
  {
    field: "total_vacancies",
    headerName: "Total Vac",
    description: "Total Vacancies (Per Client)",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
    // valueGetter: (params) =>
    //   `${params.row.avg_cost_per_hire || ""} ${params.row.name || ""}`,
  },
];

const columnsTTF = [
  {
    field: "name",
    headerName: "Position",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "client_name",
    headerName: "Client",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "time_to_fill",
    headerName: "Time To Fill",
    description: "Time To Fill/ Ending Soonest (days)",
    type: "number",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export default function AdminTable() {
  let { stats, positions, statsByClient } = useContext(DataContext);

  const [subChart, setSubChart] = useState("most-important");

  var rows = Object.entries(statsByClient).map((item) => ({
    id: item[0],
    name: item[1].client_name,
    avg_cost_per_hire: item[1].avg_cost_per_hire,
    total_hiring_costs: item[1].total_hiring_costs,
    avg_turnover_rate: item[1].avg_turnover_rate,
    total_vacancies: item[1].total_vacancies,
  }));

  var rowsTTF = positions
    .filter(function (item) {
      return item.time_to_fill != null;
    })
    .sort(function (a, b) {
      var keyA = a.time_to_fill,
        keyB = b.time_to_fill;
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });

  const handleChange = (value) => {
    setSubChart(value);
  };

  return (
    <Card>
      <CardHeader
        action={
          <Box sx={{ mr: 2 }}>
            <FormControl fullWidth color="secondary">
              <NativeSelect
                defaultValue={"most-important"}
                onChange={(e) => handleChange(e.target.value)}
              >
                <option value={"most-important"}>Positions</option>
                <option value={"overview"}>Client Stats</option>
              </NativeSelect>
            </FormControl>
          </Box>
        }
        title="Data Table"
      />
      <Divider />
      <CardContent>
        <div style={{ height: 300, width: "100%" }}>
          {subChart === "most-important" ? (
            <DataGrid
              rows={rowsTTF}
              columns={columnsTTF}
              pageSize={20}
              rowsPerPageOptions={[20]}
              checkboxSelecheckboxSelection={false}
              initialState={{
                sorting: {
                  sortModel: [{ field: "time_to_fill", sort: "asc" }],
                },
              }}
            />
          ) : (
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={20}
              rowsPerPageOptions={[20]}
              checkboxSelecheckboxSelection={false}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
